const getGeneralResourceFile = require('utils/LanguageLocale').getGeneralResourceFile;
module.exports = function getResource(label, vars = []) {
    const getGeneralResource = getGeneralResourceFile();
    let resources = {
        aboutYouTitle: 'About You',
        aboutMeTitle: 'This optional information helps make your review more useful to other shoppers.',
        noteText: 'Unless otherwise noted, any information you supply will become part of your public profile when you submit your review.',
        termsOfUseLabel: 'See Terms of Use',
        postReviewLabel: 'Post Review',
        postErrorText: 'Something went wrong, please try again later',
        postedReviewMessageText: 'Reviews are typically posted within 72 hours of the time you submit them, so stay tuned. Thank you for helping to make the Sephora community better!',
        headlineLabel: 'Headline',
        optionalLabel: '(optional)',
        selectShadeTitle: 'Select a Shade',
        writeYourReviewLabel: 'Write your review',
        seeFullLabel: 'See full',
        'r&rGuidelinesLabel': 'Ratings & Reviews guidelines',
        addPhotoLabel: 'Add photo',
        removePhotoLabel: 'Remove Photo',
        imagesLimitLabel: '(up to two images)',
        recommendThisProduct: 'Would you recommend this product?',
        continueShoppingLabel: 'Continue Shopping'
    };

    return resources[label] || getGeneralResource(label);
};
